import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useSettings = () =>
  useQuery({ queryKey: ["settings"], queryFn: async () => (await api.get("/settings")).data });

export const useVehicles = () =>
  useQuery({ queryKey: ["vehicles"], queryFn: async () => (await api.get("/vehicles")).data });

export const useVehicle = (slug) =>
  useQuery({ queryKey: ["vehicle", slug], queryFn: async () => (await api.get(`/vehicles/${slug}`)).data, enabled: !!slug });

export const useGallery = () =>
  useQuery({ queryKey: ["gallery"], queryFn: async () => (await api.get("/gallery")).data });

export const useOffers = () =>
  useQuery({ queryKey: ["offers"], queryFn: async () => (await api.get("/offers")).data });
